import PortfolioValueTooltip from './PortfolioValueTooltip';
import { TooltipProps } from 'recharts';

interface PortfolioHistoryChartTooltipProps extends TooltipProps<any, any> {}

export default function PortfolioHistoryChartTooltip(props: PortfolioHistoryChartTooltipProps) {
    const { payload, active } = props;
    const historyData = payload?.[0]?.payload;

    const label = historyData?.date?.format('D MMMM, YYYY') || '';

    return <PortfolioValueTooltip payload={payload} active={active} label={label} />;
}
